module.exports = __webpack_public_path__ + "img/xiangjin4.610c7706.png";